import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    users: [],
};

const UserSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        getAllUsers: (state, action) => {
            state.users = action.payload;
        },
    },
});

export const { getAllUsers } = UserSlice.actions;
export default UserSlice.reducer;
